<template>
  <div class="tab">
    <div>
      <slot />
    </div>
    <div
      v-if="!!$slots.actions && hasSlotContent($slots.actions)"
    >
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  hasSlotContent,
} from '../../utils/vue.ts';
</script>

<style lang="scss">
.tab {
  width: 100%;
  padding: var(--gap-section) var(--gap-section) var(--gap);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
